import { useState } from 'react';
import { Link } from 'react-router-dom';

const AccountSection = () => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState('');
  const [passwordForm, setPasswordForm] = useState({ current: '', newPass: '', confirm: '' });
  const [showCurrentPass, setShowCurrentPass] = useState(false);
  const [showNewPass, setShowNewPass] = useState(false);
  const [passSaving, setPassSaving] = useState(false);
  const [passSaved, setPassSaved] = useState(false);
  const [passError, setPassError] = useState('');

  const handlePasswordChange = (e: React.FormEvent) => {
    e.preventDefault();
    setPassError('');
    if (!passwordForm.current) { setPassError('Mevcut şifrenizi girin.'); return; }
    if (passwordForm.newPass.length < 8) { setPassError('Yeni şifre en az 8 karakter olmalı.'); return; }
    if (passwordForm.newPass !== passwordForm.confirm) { setPassError('Yeni şifreler eşleşmiyor.'); return; }
    setPassSaving(true);
    setTimeout(() => {
      setPassSaving(false);
      setPassSaved(true);
      setPasswordForm({ current: '', newPass: '', confirm: '' });
      setTimeout(() => setPassSaved(false), 3000);
    }, 1000);
  };

  return (
    <div>
      <div className="mb-8">
        <h2 className="text-xl font-extrabold text-white mb-1">Hesap</h2>
        <p className="text-white/40 text-sm">Hesap bilgilerin ve güvenlik ayarların.</p>
      </div>

      <div className="flex flex-col gap-6">
        {/* Subscription status */}
        <div className="p-6 rounded-2xl bg-white/3 border border-white/8">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-white/70 font-semibold text-sm">Abonelik Durumu</h3>
          </div>
          <div className="flex items-center justify-between p-4 rounded-xl bg-white/3 border border-white/8">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-white/6 text-white/35">
                <i className="ri-user-line text-lg" />
              </div>
              <div>
                <p className="text-white font-bold text-sm">Ücretsiz Plan</p>
                <p className="text-white/35 text-xs">Temel özellikler aktif</p>
              </div>
            </div>
            <Link
              to="/premium"
              className="px-4 py-2 rounded-full bg-gradient-to-r from-yellow-500 to-orange-500 text-black text-xs font-extrabold hover:from-yellow-400 hover:to-orange-400 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-vip-crown-line mr-1" />
              Premium'a Geç
            </Link>
          </div>
        </div>

        {/* Email */}
        <div className="p-6 rounded-2xl bg-white/3 border border-white/8">
          <h3 className="text-white/70 font-semibold text-sm mb-4">E-posta Adresi</h3>
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
            <div className="flex-1 flex items-center gap-3 px-4 py-3 rounded-xl bg-white/5 border border-white/10">
              <i className="ri-mail-line text-white/30 text-sm flex-shrink-0" />
              <span className="text-white/60 text-sm">ornek@email.com</span>
              <span className="ml-auto px-2 py-0.5 rounded-full bg-emerald-500/15 text-emerald-400 text-xs border border-emerald-500/25 flex-shrink-0">Doğrulandı</span>
            </div>
            <button className="px-4 py-3 rounded-xl bg-white/6 border border-white/12 text-white/55 text-sm font-medium hover:bg-white/10 hover:text-white/80 transition-all cursor-pointer whitespace-nowrap">
              Değiştir
            </button>
          </div>
        </div>

        {/* Password change */}
        <div className="p-6 rounded-2xl bg-white/3 border border-white/8">
          <h3 className="text-white/70 font-semibold text-sm mb-5">Şifre Değiştir</h3>
          <form onSubmit={handlePasswordChange} className="flex flex-col gap-4">
            {/* Current password */}
            <div>
              <label className="block text-white/40 text-xs font-semibold uppercase tracking-widest mb-2">Mevcut Şifre</label>
              <div className="relative">
                <i className="ri-lock-line absolute left-4 top-1/2 -translate-y-1/2 text-white/25 text-sm" />
                <input
                  type={showCurrentPass ? 'text' : 'password'}
                  value={passwordForm.current}
                  onChange={(e) => setPasswordForm({ ...passwordForm, current: e.target.value })}
                  placeholder="••••••••"
                  className="w-full pl-10 pr-12 py-3.5 rounded-xl bg-white/5 border border-white/10 text-white text-sm placeholder-white/20 focus:outline-none focus:border-cyan-500/50 transition-colors"
                />
                <button type="button" onClick={() => setShowCurrentPass(!showCurrentPass)} className="absolute right-4 top-1/2 -translate-y-1/2 text-white/25 hover:text-white/50 cursor-pointer">
                  <i className={showCurrentPass ? 'ri-eye-off-line' : 'ri-eye-line'} />
                </button>
              </div>
            </div>
            {/* New password */}
            <div>
              <label className="block text-white/40 text-xs font-semibold uppercase tracking-widest mb-2">Yeni Şifre</label>
              <div className="relative">
                <i className="ri-lock-2-line absolute left-4 top-1/2 -translate-y-1/2 text-white/25 text-sm" />
                <input
                  type={showNewPass ? 'text' : 'password'}
                  value={passwordForm.newPass}
                  onChange={(e) => setPasswordForm({ ...passwordForm, newPass: e.target.value })}
                  placeholder="En az 8 karakter"
                  className="w-full pl-10 pr-12 py-3.5 rounded-xl bg-white/5 border border-white/10 text-white text-sm placeholder-white/20 focus:outline-none focus:border-cyan-500/50 transition-colors"
                />
                <button type="button" onClick={() => setShowNewPass(!showNewPass)} className="absolute right-4 top-1/2 -translate-y-1/2 text-white/25 hover:text-white/50 cursor-pointer">
                  <i className={showNewPass ? 'ri-eye-off-line' : 'ri-eye-line'} />
                </button>
              </div>
              {/* Strength */}
              {passwordForm.newPass && (
                <div className="flex gap-1 mt-2">
                  {[1,2,3,4].map((lvl) => (
                    <div key={lvl} className={`flex-1 h-1 rounded-full transition-colors ${passwordForm.newPass.length >= lvl * 3 ? lvl <= 1 ? 'bg-red-500' : lvl <= 2 ? 'bg-yellow-500' : lvl <= 3 ? 'bg-cyan-500' : 'bg-emerald-500' : 'bg-white/8'}`} />
                  ))}
                </div>
              )}
            </div>
            {/* Confirm */}
            <div>
              <label className="block text-white/40 text-xs font-semibold uppercase tracking-widest mb-2">Yeni Şifre (Tekrar)</label>
              <div className="relative">
                <i className="ri-lock-2-line absolute left-4 top-1/2 -translate-y-1/2 text-white/25 text-sm" />
                <input
                  type="password"
                  value={passwordForm.confirm}
                  onChange={(e) => setPasswordForm({ ...passwordForm, confirm: e.target.value })}
                  placeholder="Yeni şifreni tekrar gir"
                  className="w-full pl-10 pr-4 py-3.5 rounded-xl bg-white/5 border border-white/10 text-white text-sm placeholder-white/20 focus:outline-none focus:border-cyan-500/50 transition-colors"
                />
              </div>
            </div>

            {passError && (
              <div className="flex items-center gap-2 px-4 py-3 rounded-xl bg-red-500/8 border border-red-500/20 text-red-400 text-xs">
                <i className="ri-error-warning-line" /> {passError}
              </div>
            )}
            {passSaved && (
              <div className="flex items-center gap-2 px-4 py-3 rounded-xl bg-emerald-500/8 border border-emerald-500/20 text-emerald-400 text-xs">
                <i className="ri-checkbox-circle-line" /> Şifre başarıyla güncellendi!
              </div>
            )}

            <button
              type="submit"
              disabled={passSaving}
              className="w-fit px-8 py-3.5 rounded-full bg-gradient-to-r from-cyan-500 to-violet-600 text-white font-bold text-sm hover:from-cyan-400 hover:to-violet-500 transition-all cursor-pointer disabled:opacity-60 whitespace-nowrap"
            >
              {passSaving ? <span className="flex items-center gap-2"><i className="ri-loader-4-line animate-spin" /> Güncelleniyor...</span> : 'Şifreyi Güncelle'}
            </button>
          </form>
        </div>

        {/* Danger zone — delete account */}
        <div className="p-6 rounded-2xl bg-red-500/4 border border-red-500/15">
          <h3 className="text-red-400 font-bold text-sm mb-2 flex items-center gap-2">
            <i className="ri-delete-bin-line" /> Hesabı Sil
          </h3>
          <p className="text-white/40 text-xs mb-4 leading-relaxed">
            Hesabını kalıcı olarak silmek istiyorsan aşağıdaki butona tıkla. Bu işlem geri alınamaz.
          </p>
          <button
            onClick={() => setShowDeleteModal(true)}
            className="px-5 py-2.5 rounded-xl bg-red-500/12 border border-red-500/25 text-red-400 text-sm font-semibold hover:bg-red-500/20 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-delete-bin-line mr-2" />
            Hesabımı Sil
          </button>
        </div>
      </div>

      {/* Delete confirmation modal */}
      {showDeleteModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
          <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={() => setShowDeleteModal(false)} />
          <div className="relative w-full max-w-md bg-[#0d1117] border border-red-500/20 rounded-3xl p-8">
            <div className="w-14 h-14 rounded-2xl bg-red-500/15 border border-red-500/25 flex items-center justify-center mx-auto mb-5">
              <i className="ri-delete-bin-line text-red-400 text-2xl" />
            </div>
            <h3 className="text-white font-extrabold text-xl text-center mb-2">Hesabı Sil</h3>
            <p className="text-white/45 text-sm text-center mb-6 leading-relaxed">
              Bu işlem geri alınamaz. Tüm verileriniz kalıcı olarak silinir.
              Devam etmek için aşağıya <strong className="text-white">SİL</strong> yazın.
            </p>
            <input
              type="text"
              value={deleteConfirm}
              onChange={(e) => setDeleteConfirm(e.target.value)}
              placeholder="SİL"
              className="w-full px-4 py-3.5 rounded-xl bg-white/5 border border-white/10 text-white text-sm placeholder-white/25 focus:outline-none focus:border-red-500/50 mb-4 text-center font-bold tracking-widest"
            />
            <div className="flex gap-3">
              <button
                onClick={() => setShowDeleteModal(false)}
                className="flex-1 py-3 rounded-full bg-white/6 border border-white/12 text-white/60 text-sm hover:bg-white/10 transition-all cursor-pointer"
              >
                Vazgeç
              </button>
              <button
                disabled={deleteConfirm !== 'SİL'}
                className="flex-1 py-3 rounded-full bg-red-500 text-white text-sm font-bold hover:bg-red-400 transition-all cursor-pointer disabled:opacity-30 disabled:cursor-not-allowed"
              >
                Hesabı Kalıcı Sil
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AccountSection;
